<template>
    <div class="">
        <v-img :src="garage"  class=" " max-height="400" max-width="100%"
        gradient="to top right, rgba(100,115,201,.3), rgba(25,32,72,.7)">
        <v-row>
             <v-col cols="12" align="center"   >
            <h4 class="primary--text text-uppercase  mt-16 text-h4">ABOUT US</h4>
             </v-col>
       </v-row>
     </v-img>
        
        <v-row class="py-16 px-5">
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6">

                    <h2 class="">Our Vision</h2>
                </v-col>

                    <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6">
                        
                    <p>
                        <strong>Kasana Auto Garage</strong> Limited's core values comprise integrity, customer satisfaction, quality, and safety. These values outline 
                        the essential elements that govern the smooth operation of the company and contribute to its success in achieving its goals
                        and objectives.
                    </p>
            </v-col>
            </v-row>
                <v-row class=" py-16 primary px-4 ">
                    <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6">

                    <h2 class="">Our Mission</h2>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6">

                        
                    <p>
                        At Kasana Auto Garage, our mission is to deliver exceptional automotive services that prioritize safety, reliability, and customer satisfaction.
                        We are committed to using high-quality parts and the latest technology to ensure your vehicle performs at its best. Our team of skilled 
                        technicians is dedicated to providing honest, transparent, and efficient service that you can trust every time.
                    </p>
            </v-col>
        </v-row>

        <v-img :src="our"  class=" " max-height="400" max-width="100%"
        gradient="to top right, rgba(100,115,201,.3), rgba(25,32,72,.7)">
        <v-row class="pa-5 py-16">
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6">

                    <h2 class="white--text">Our Goals</h2>
                </v-col>
                    <v-col>
                        
                    <p class="white--text">
                        <strong>1. Customer Satisfaction:</strong> We aim to exceed customer expectations by providing top-notch service and building long-term relationships based on trust and integrity. <br>
                        <strong>2. Safety First:</strong> Our goal is to ensure that every vehicle we service is safe and road-ready, giving our customers peace of mind. <br>
                        <strong>3. Quality Service:</strong> We strive to maintain the highest standards of workmanship.
                    </p>
            </v-col>
        </v-row></v-img>

        <v-row class="pa-5 py-16 light-purple" >
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6">

            
                    <h2 class="">About Our Company</h2>
                </v-col>
                <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6">

                        
                    <p>
                        Founded in August 2023, our company has grown from a small startup to a respected
                        name in the industry, known for its commitment to quality and excellence. We believe 
                        in harnessing technology to create value and improve lives.
                    </p>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "AboutUs",
        data(){
            return {
                garage: require('@/assets/images/motorgarage.jpg'),
                our: require('@/assets/car3.jpg'),
            }
        }
    }
</script>

<style scoped>
/* .about {
    padding: 20px;
    background-color: #f0f4f8; 
}

.title {
    color: #1976d2;
}

.card {
    background-color: #ffffff; 
    border: 1px solid #e0e0e0; 
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card-content {
    padding: 16px;
}

.card:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.bg {
    border-left: 5px solid #1976d2; 
}

.bgg {
    border-left: 5px solid #4caf50; 
}

.bggg {
    border-left: 5px solid #ff9800; 
}

h2 {
    margin-bottom: 16px;
} */
</style>
